import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import cx from 'classnames'
import { get } from 'lodash'
import { NavLink } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import { getActiveRole } from 'utils/token'
import { ROLES, ORGANIZATION_HIERARCHY } from 'constants/enums'
import { Footer } from 'containers/layout'
import styles from './sidebar.styl'
import appConfig from 'config'

import activeDotImg from 'assets/img/active-dot.png'

@injectIntl
class Sidebar extends Component {
  static propTypes = {
    links: PropTypes.array.isRequired,
    organization: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    overview: PropTypes.object,
    intl: PropTypes.object.isRequired
  }

  static defaultProps = {
    overview: {
      list: []
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      fixed: false,
      width: '100%'
    }
  }

  componentDidMount = () => this.handleScroll()

  handleScroll = () => {
    const { sidebar } = this.refs
    const rect = sidebar.getBoundingClientRect()

    window.onscroll = () => {
      const body = document.body.getBoundingClientRect()

      if (body.top + rect.top < -5) {
        if (!this.state.fixed) {
          this.setState({ fixed: true })
        }
      }

      if (body.top + rect.top > 0) {
        if (this.state.fixed) {
          this.setState({ fixed: false })
        }
      }
    }
  }

  handleGetCountNumber = (counters = [], myOnly = false) => {
    const { overview, organization } = this.props

    let counts = []

    const activeOrganizationOverview = (myOnly && overview.overviewMyOnly)
      ? overview.overviewMyOnly.list || []
      : get(overview, `byId[${organization.id}]`) || overview.list

    counters.forEach(nameId => {
      counts = counts.concat(
        activeOrganizationOverview
          .filter(item => item.nameId === nameId)
          .map(item => item.value)
      )
    })

    const count = counts.reduce((acc, cv) => {
      return acc + cv
    }, 0)

    if (count === 0) {
      return null
    }

    return <span className={styles.badge}>{count}</span>
  }

  handleLinkClasses = (item, pathname) => {
    const activeClass = pathname && (pathname === item.urlPrefix || pathname.startsWith(item.urlPrefix + '/'))
      ? styles.active
      : ''

    return cx(styles.link, {
        [styles.withBadge]: item.counters
      },
      activeClass)
  }

  render() {
    const { intl, links, organization, configuration, location } = this.props

    const { fixed, width } = this.state

    const fixedWidth = fixed ? width : '100%'

    const role = getActiveRole(organization)
    const hierarchyLevelType = get(organization, 'hierarchyLevelType.value')

    let filterredLinks = links.filter(link => {
      if (link.configs) {
        return link.configs.some(item => {
          return (
            configuration.values[item] &&
            configuration.values[item].booleanValue &&
            link.roles.some(
              itemRole => itemRole === role || itemRole === ROLES.ALL.u
            )
          )
        })
      }

      return link.roles.some(
        itemRole => itemRole === role || itemRole === ROLES.ALL.u
      )
    })

    filterredLinks = filterredLinks.filter(link => {
        if (link.configuration) {
        return get(configuration, `values[${link.configuration}].booleanValue`)
        }
        return true
    })

    filterredLinks = filterredLinks.filter(link => {
      if (link.orgHierarchyTypes) {
        return link.orgHierarchyTypes.some(
            type => type === hierarchyLevelType || type === ORGANIZATION_HIERARCHY.ALL.u
        )
      }
      return true
    })

    return (
      <nav
        ref="sidebar"
        style={{ width: fixedWidth }}
      >
        <ul className={styles.list}>
          {filterredLinks.map(item => {
            const linkMessage = intl.formatMessage({
              id: item.message,
              defaultMessage: item.defaultMessage
            })
            const countNumber = this.handleGetCountNumber(item.counters, item.countersMyOnly)

            return (
              <li
                className={styles.item}
                key={item.id}
              >
                <NavLink
                  to={item.url}
                  className={this.handleLinkClasses(item, get(location, 'pathname'))}
                >
                  <class className={`ico ico--${item.icon} ${styles.icon}`} />
                  <ReactTooltip effect='solid' type='info' className={`${styles.tooltip}`} />
                  <span className={`${styles.itemTitle}`}>
                    {linkMessage}
                    {item.counters && countNumber}
                  </span>
                  {item.counters && countNumber &&
                    <img className={styles.activeDot}
                         src={activeDotImg}
                    />
                  }
                </NavLink>
              </li>
            )
          })}
        </ul>
        {appConfig.displayVersion && (
          <div className={styles.footer}>
            <Footer />
          </div>
        )}
      </nav>
    )
  }
}

export default Sidebar
